<dialog-header
  [title]="data.guide.title || 'Asset Viewer'"
  (onClose)="matDialogRef.close()"
></dialog-header>
<div mat-dialog-content class="content-container">
  <div class="images-wrapper">
    <div class="image-container">
      <img
        [src]="imageUrl"
        alt="Asset"
        (click)="openFullScreenImage(imageUrl, 'Asset')"
        class="clickable-image"
      />
      <div class="image-label">Asset</div>
    </div>

    <div class="mockup-container" *ngIf="hasMockup && mockupUrl">
      <img
        [src]="mockupUrl"
        alt="Example Usage"
        (click)="openFullScreenImage(mockupUrl, 'Example Usage')"
        class="clickable-image"
      />
      <div class="image-label">Example Usage</div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="actions-container">
  <div class="left-controls">
    <div class="location-picker" *ngIf="hasMultipleLocations">
      <single-select
        [formCtrl]="locationFormControl"
        [options]="locations"
        [property]="'name'"
        [inBrackets]="'formattedAddress'"
        [value]="locationFormControl.value"
        (selected)="onLocationChange($event)"
        [disabled]="locationsLoading"
      ></single-select>
    </div>

    <div class="size-selector" *ngIf="hasMultipleSizes">
      <single-select
        [formCtrl]="sizeFormControl"
        [options]="imageSizes"
        [property]="'label'"
        [value]="sizeFormControl.value"
        (selected)="onSizeChange($event.value)"
        [disabled]="loading"
        [inBrackets]="'description'"
      ></single-select>
    </div>
  </div>

  <div class="right-controls">
    <app-primary-button
      [disabled]="loading"
      [title]="'Download'"
      (tapped)="downloadImage()"
      bgColor="var(--app-timber)"
      color="white"
      icon="download"
    ></app-primary-button>
  </div>
</div>

<loader [loading]="loading"></loader>
